import request from '@/utils/request.js'
export function getLocationExport(data) {
  return request({
    url: 'n360/mcmnt/api/location/get-locations-has-authority',
    method: 'post',
    data
  })
}
export function getLocationImport(data) {
  return request({
    url: 'n360/mcmnt/api/location/list',
    method: 'post',
    data
  })
}
export function getInventorys(data) {
  return request({
    url: '/nsh/inventory/api/inventory/list',
    method: 'post',
    data
  })
}
export function getSerialBySKUInventory(data) {
  return request({
    url: '/proxy-gateway/gw-core/product-series/search',
    method: 'post',
    data
  })
}
export function getItemCompoud(data) {
  return request({
    url: '/proxy-gateway/gw-core/item-compound/search-v2',
    method: 'post',
    data
  })
}
export function getInventoryById(data) {
  return request({
    url: '/nsh/odm/api/order/io/' + data.id,
    method: 'get'
  })
}
export function getItemByCategory(data) {
  return request({
    url: `/nsh/item/item-compounds/search`,
    method: 'post',
    data
  })
}
export function getItemByCategoryV2(data) {
  return request({
    url: `/nsh/item/item-compounds/item-instances/search`,
    method: 'post',
    data
  })
}